module.exports = {

    data() {
        return {
            use_search_box: true,
            searchKey: '',
        }
    },

    methods: {
        onSearch: _.debounce(function() {
            if (this[this.onSearchMethod] != undefined) {
                this[this.onSearchMethod]();
            }
        }, 300),
    }
}
